import { useEffect, useState } from 'react'
import { GET_APPLICATION_BOOKING } from 'src/constants/Api'
import { PublicBooking } from 'src/redux/slices/Booking'
import client from 'src/utils/client'
import { HookReturn, HookProps } from './Type'

export const useApplicationBooking = ({
  applicationId,
  skipFetchOnInit,
}: HookProps): HookReturn => {
  const [booking, setBooking] = useState<PublicBooking | undefined>(undefined)
  const getBooking = async (id?: string): Promise<PublicBooking | false> => {
    try {
      if (id && id !== '') {
        const fetch = await client<{
          count: number
          next: string
          previous: string
          results: PublicBooking[]
        }>(GET_APPLICATION_BOOKING(id))
        if (fetch) {
          setBooking(fetch.results[0])
          return fetch.results[0]
        }
      }
      return false
    } catch (err) {
      /**/
      return false
    }
  }

  useEffect(() => {
    if (applicationId && applicationId !== '' && !skipFetchOnInit) {
      getBooking(applicationId)
    }
  }, [applicationId])

  return {
    booking,
    fetchBooking: getBooking,
  }
}
